<template>
  <div>
    <van-nav-bar
      title="资料列表"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      />
    <myData :dataList="dataList" />
  </div>
</template>

<script>
import myData from "@/components/common/myData/myData"
export default {
  components:{
    myData
  },
  created(){
    this.getDataList()
  },
  data(){
    return {
      pid:"",
      dataList:[],
    }
  },
  methods:{
    getDataList(){
      this.pid = this.$route.query.pid
      let _that = this
      this.Api({
        url:`api/datumListByPid?pid=${_that.pid}`,
        method:"GET"
      }).then(res => {
        if(res.retuCode == 5000){
          _that.dataList = res.data
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
